import { STORE_NAME } from '@intigral/constant';
import { get } from '@intigral/utils/lib/browser-storage/localStorage';

const getPPVDetails = (modalContent, selectedProgram, ppvEventConfig) => {
    // PPV detection logic for modalContent
    const userInfo = get(STORE_NAME.USER);
    const userPpvList = userInfo?.ppvList || [];
    const subscriptionGUID = modalContent?.channel?.subscriptions?.[0]?.subscriptionGUID;
    const isPPVPurchased = subscriptionGUID && userPpvList.some((ppv: any) => ppv.guid === subscriptionGUID);

    // Check if this is a PPV program
    const channelIsPPV = modalContent?.channel?.isPPV || subscriptionGUID?.includes('PPV');
    const programIsPPV = modalContent?.isPPV;
    const isPPV = programIsPPV || channelIsPPV;

    // Enhanced PPV data extraction - try selectedProgram first (it's enhanced by EPG handlers)
    let ppvEvent = modalContent?.ppvEvent;
    let ppvEventId = modalContent?.ppvEventId || modalContent?.eventId || ppvEvent?.eventId;
    let ppvPrice = modalContent?.ppvPrice || ppvEvent?.price;
    let ppvCurrency = modalContent?.ppvCurrency || ppvEvent?.currency;

    // Check if selectedProgram has better PPV data (enhanced by EPG handlers)
    if (selectedProgram && modalContent?.id === selectedProgram?.id) {
        ppvEvent = ppvEvent || selectedProgram.ppvEvent;
        ppvEventId = ppvEventId || selectedProgram.ppvEventId;
        ppvPrice = ppvPrice || selectedProgram.ppvPrice;
        ppvCurrency = ppvCurrency || selectedProgram.ppvCurrency;
    }

    // Simple direct lookup: Get subscription GUID and find matching event in config
    if (isPPV && (!ppvEvent || !ppvPrice || ppvPrice === '0') && ppvEventConfig && subscriptionGUID) {
        // Get PPV events - handle both array and nested data structure
        const ppvEvents = Array.isArray(ppvEventConfig) ? ppvEventConfig : ppvEventConfig?.data || [];

        // Find event that matches this subscription GUID - try both property names
        const matchingEvent = ppvEvents.find(
            (event: any) => event.subscriptionGuid === subscriptionGUID || event.subscriptionGUID === subscriptionGUID
        );

        if (matchingEvent) {
            ppvEvent = matchingEvent;
            ppvEventId = matchingEvent.eventId; // Real UUID
            ppvPrice = matchingEvent.price; // Real price
            ppvCurrency = matchingEvent.currency; // Real currency
        }
    }

    // If still missing data, try fallback extraction from subscription GUID
    const hasIncompletePPVData = isPPV && !ppvEvent && !ppvEventId;
    if (hasIncompletePPVData && subscriptionGUID) {
        // Try different patterns for extracting eventId from subscriptionGUID
        let extractedEventId = null;

        // Pattern 1: "PPV_X_SUBSCRIPTION" -> X
        let guidMatch = subscriptionGUID.match(/PPV_(\d+)_/);
        if (guidMatch) {
            extractedEventId = guidMatch[1];
        } else {
            // Pattern 2: "PPV_X" -> X
            guidMatch = subscriptionGUID.match(/PPV_(\d+)$/);
            if (guidMatch) {
                extractedEventId = guidMatch[1];
            } else {
                // Pattern 3: Extract any number from the GUID
                guidMatch = subscriptionGUID.match(/(\d+)/);
                if (guidMatch) {
                    extractedEventId = guidMatch[1];
                }
            }
        }

        if (extractedEventId) {
            ppvEventId = extractedEventId;
        }

        // Set default values if still missing
        ppvPrice = ppvPrice || '0';
        ppvCurrency = ppvCurrency || 'SAR';
    }

    return { isPPV, isPPVPurchased, ppvEventId, ppvPrice, ppvCurrency };
};
export default getPPVDetails;
